<template>
  <span>
    <saisie-search @searchUpdate="updateSearch"></saisie-search>

    <div>
      <strong>Dépense : </strong>
      <span class="m-2 text-danger">{{ totauxCalcul.totalDepense }}</span>
      <strong>Recette : </strong>
      <span class="m-2 text-success">{{ totauxCalcul.totalRecette }}</span>
      <strong> Balance :</strong>
      <span class="m-2 text-info">{{ totauxCalcul.balance }}</span>
    </div>
    <span @mouseleave="actionButtonsIndex = -10">
      <b-table
        ref="table"
        :current-page="pagination.currentPage"
        :fields="tableColumns"
        :items="myProvider"
        :per-page="pagination.perPage"
        :sort-by="search.orderBy"
        :sort-desc="true"
        class="pointer-table"
        hoverref="table"
        stacked="md"
        striped
        @row-clicked="showDetail"
        @row-hovered="toggleActionButtons"
      >
        <template #cell(fichiers)="row">
          <font-awesome-icon
            v-if="row.item.justificatifs.length > 0"
            class="ml-2"
            icon="file"
          />
          <font-awesome-icon
            v-if="canShowDetail(row)"
            class="ml-2"
            icon="info"
          />
        </template>

        <!-- Template pour la colorisation des type de catégorie -->
        <template #cell(categorieLibelle)="row">
          <span :class="categorieClass(row.item)">
            {{ row.item.categorieLibelle }}
          </span>
        </template>
        <!-- Action possible sur la ligne -->
        <template #cell(Actions)="row">
          <span v-if="row.index === actionButtonsIndex" @click.stop>
            <font-awesome-icon
              class="pointer ml-2"
              icon="edit"
              @click.stop="onSelectEdit(row.item)"
            />
            <font-awesome-icon
              v-b-modal.confirmDeleteModalSaisie
              class="pointer ml-2"
              icon="trash-alt"
              @click.stop="onSelectDelete(row.item)"
            />
          </span>
          <span v-else>
            <!-- bidouille pour pas que la tableau soit en "fixed" et qu'il ne bouge à l'affichage des icones d'actions
                                  on ajustera le nombre de a en fonction de la taille des icones-->
            <div class="transparentColor">aaaaaaaa</div>
          </span>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <b-row
              v-if="row.item.montant !== row.item.montantEuro"
              class="mb-20"
            >
              <b-col cols="2"><b>Montant en devise</b></b-col>
              <b-col cols="2">{{ row.item.montant }}</b-col>

              <b-col cols="2"><b>Taux de change:</b></b-col>
              <b-col cols="2">{{ row.item.tauxChange }}</b-col>

              <b-col cols="2"><b>Devise:</b></b-col>
              <b-col cols="2">{{ row.item.devise }}</b-col>
            </b-row>
            <b-row>
              <b-col v-if="row.item.adherent" cols="2"><b>Adherent:</b></b-col>
              <b-col v-if="row.item.adherent" cols="2">{{
                row.item.adherent
              }}</b-col>
            </b-row>
            <b-row>
              <b-col v-if="row.item.commentaire" cols="2"
                ><b>Commentaire:</b></b-col
              >
              <b-col v-if="row.item.commentaire" cols="2">{{
                row.item.commentaire
              }}</b-col>
            </b-row>
            <b-card
              v-if="row.item.justificatifs && row.item.justificatifs.length > 0"
              class="mt-3"
            >
              <b-row
                v-for="justificatif in row.item.justificatifs"
                :key="justificatif.id"
                class="pointer"
                @click="downloadJustificatif(justificatif)"
              >
                <b-col>
                  {{ justificatif.fileName }}
                  <font-awesome-icon class="ml-2" icon="file" />
                </b-col>
              </b-row>
            </b-card>
          </b-card>
        </template>
      </b-table>
    </span>
    <div class="my-2 row justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total-rows="pagination.totalRows"
        class="my-0"
        size="sm"
      />
    </div>
    <!-- Modal pour confirmer la suppression d'un élément du tableau -->
    <b-modal
      id="confirmDeleteModalSaisie"
      ref="confirmDeleteModalSaisie"
      centered
      title="Suppression"
      @hidden="selectedRowValue = {}"
    >
      <p class="my-4">
        Confirmez vous la suppression de la saisie
        <strong>{{ libelleToDelete }}</strong>
      </p>
      <div slot="modal-footer" class="w-100">
        <b-button
          class="m-1 float-right"
          variant="primary"
          @click.stop="onConfirmDelete()"
          >Supprimer</b-button
        >
        <b-button
          class="m-1 float-right"
          type="cancel"
          variant="danger"
          @click.stop="onCancelDelete()"
          >Annuler
        </b-button>
      </div>
    </b-modal>
  </span>
</template>

<script>
import ApiService from "../../service/apiService";
import TypeLibelleService, {
  isCategorieRecette,
} from "../../service/typeLibelleService";
import SaisieSearch from "./SaisieSearch";

export default {
  name: "SaisiePaginationTab",
  components: {
    SaisieSearch: SaisieSearch,
  },
  data() {
    return {
      libelleToDelete: "",
      actionButtonsIndex: -10,
      TypeLibelleService: TypeLibelleService,
      tableColumns: tableColumns,
      pagination: {
        currentPage: 1,
        perPage: 2,
        totalRows: 9,
      },
      search: {
        page: 0,
        perPage: 15,
        orderBy: "date",
        direction: "desc",
        search: "",
      },
      totauxCalcul: {
        totalDepense: 0,
        totalRecette: 0,
        balance: 0,
      },
    };
  },
  methods: {
    onSubmit() {
      this.refreshTable();
    },
    updateSearch(search) {
      this.search.adherentId = search.adherentId;
      this.search.categorieId = search.categorieId;
      this.search.deviseId = search.deviseId;
      this.search.modePaiementId = search.modePaiementId;
      this.search.projetId = search.projetId;
      this.search.search = search.search;
      this.search.year = search.year;
      this.refreshTable();
    },
    refreshTable() {
      this.$refs.table.refresh();
    },

    async downloadJustificatif(justificatif) {
      let res = await ApiService.justificatifs.downloadJustificatif(
        justificatif.id
      );
      if (res) {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", justificatif.fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
      }
    },
    myProvider(ctx, callback) {
      this.updateSearchObject(ctx);
      ApiService.saisie
        .search(this.search)
        .then((resp) => {
          let data = resp.data;
          //On set les calculs des saisies
          this.totauxCalcul.totalDepense = data.totalDepense;
          this.totauxCalcul.totalRecette = data.totalRecette;
          this.totauxCalcul.balance = data.balance;

          this.pagination.perPage = data.saisiePage.size;
          this.pagination.totalRows = data.saisiePage.totalElements;
          this.pagination.currentPage = data.saisiePage.number + 1;
          callback(data.saisiePage.content);
        })
        .catch(() => {
          this.pagination.perPage = 0;
          this.pagination.totalRows = 0;
          this.pagination.currentPage = 1;
          callback([]);
        });

      return null;
    },

    updateSearchObject(ctx) {
      this.search.orderBy = ctx.sortBy || "date";
      this.search.direction = ctx.sortDesc ? "DESC" : "ASC";
      this.search.page = ctx.currentPage - 1;
    },
    categorieClass(item) {
      let classe = "";
      if (item.typeSaisie) {
        classe = isCategorieRecette(item.typeSaisie)
          ? "text-success"
          : "text-danger";
      }
      return classe;
    },
    onSelectDelete(item) {
      this.libelleToDelete = item.libelle;
      this.selectedRowValue = item;
      this.$refs.confirmDeleteModalSaisie.show();
    },

    /**
     * Affecte l'index de la ligne du tableau de la variable actionButtonIndex
     */
    toggleActionButtons(item, index) {
      this.actionButtonsIndex = index;
    },
    /**
     * Cache la modal de confirmation de suppession
     */
    onCancelDelete() {
      this.$refs.confirmDeleteModalSaisie.hide();
    },
    /**
     * Envoi l'élémet à supprimer dans un evenement
     */
    onConfirmDelete() {
      this.$emit("deleteConfirmed", this.selectedRowValue);
      //On ferme la modal
      this.$refs.confirmDeleteModalSaisie.hide();
    },
    onSelectEdit(item) {
      this.$emit("editSelected", item);
    },
    canShowDetail(row) {
      if (row && row.item) {
        let item = row.item;
        return item.tauxChange != 1 || item.adherent || item.commentaire;
      }
    },
    showDetail(item) {
      if (item.tauxChange != 1 || item.adherent || item.commentaire) {
        this.$set(item, "_showDetails", !item._showDetails);
      }
    },
  },
};
//Je met ça ici pour épurer l'attribut data
const tableColumns = [
  {
    key: "date",
    label: "Date",
    sortable: true,
  },
  {
    key: "libelle",
    label: "Libelle",
    sortable: true,
  },
  {
    key: "montantEuro",
    label: "Montant (€)",
    sortable: true,
  },

  {
    key: "modePaiementLibelle",
    label: "Mode de paiement",
    sortable: true,
  },
  {
    key: "categorieLibelle",
    label: "Catégorie",
    sortable: true,
  },
  {
    key: "projetLibelle",
    label: "Projet",
    sortable: true,
  },
  {
    key: "fichiers",
    label: "",
  },
  {
    key: "Actions",
    label: "",
  },
];
</script>
